import { RootState } from "@/store/store";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";
import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";
import { gridResourcesCurrentCleanMasterGridIdSelector } from "@/store/resources-grid/selectors/clean/gridResourcesCurrentCleanMasterGridIdSelector";
import { gridResourcesCurrentCleanActionSelector } from "@/store/resources-grid/selectors/clean/gridResourcesCurrentCleanActionSelector";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";

type ReturnType = {
  excluded: AllTypeResourcesData[];
  included: AllTypeResourcesData[];
};

export const gridResourcesCurrentCleanResourcesGroupedByExcludeIncludeSelector =
  (state: RootState): ReturnType => {
    const masterGridId = gridResourcesCurrentCleanMasterGridIdSelector(state);

    if (!masterGridId) {
      return initialState;
    }

    const resources = selectedResourcesByMasterIdSelector(state, masterGridId);
    const cleanAction = gridResourcesCurrentCleanActionSelector(state);

    if (!resources) {
      return initialState;
    }

    return resources.reduce(
      (acc, resource) => {
        if (!resource) {
          return acc;
        }

        const canDoAction =
          cleanAction && resource.not_allowed_actions?.includes(cleanAction);

        const accessType = isResourceKubernetes(resource)
          ? "read"
          : resource.account.provider_access_type;

        const exclude =
          accessType === "read" ||
          resource.is_protected ||
          resource.marked_for_deletion ||
          !!canDoAction;

        if (exclude) {
          acc.excluded.push({
            resource,
            id: resource.id,
          } as AllTypeResourcesData);
        } else {
          acc.included.push({
            resource,
            id: resource.id,
          } as AllTypeResourcesData);
        }

        return acc;
      },
      { excluded: [], included: [] } as ReturnType,
    );
  };

const initialState = { excluded: [], included: [] };
